var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuTas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.23999 16.54V11.08C0.23999 9.03997 0.59999 7.15997 1.31999 5.43997C2.03999 3.71997 3.25999 1.97997 4.97999 0.219971L8.09999 2.67997C6.81999 3.99997 5.91999 5.21997 5.39999 6.33997C4.87999 7.45997 4.61999 8.65997 4.61999 9.93997L2.75999 8.19997H8.63999V16.54H0.23999ZM12.18 16.54V11.08C12.18 9.03997 12.54 7.15997 13.26 5.43997C13.98 3.71997 15.2 1.97997 16.92 0.219971L20.04 2.67997C18.76 3.99997 17.86 5.21997 17.34 6.33997C16.82 7.45997 16.56 8.65997 16.56 9.93997L14.7 8.19997H20.58V16.54H12.18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuTas);
export default __webpack_public_path__ + "static/media/KuTas.3c80ab5e6bcb80cc59963572af01c760.svg";
export { ForwardRef as ReactComponent };